import { useTranslation } from "react-i18next";

import { usePermanentRealTimeUser } from "hooks";

export const useCustomerOkUserOptions = () => {
  const { user } = usePermanentRealTimeUser();
  const { t } = useTranslation();

  const customerOkUserOptions = [
    { key: "all", value: "all", text: t("v8_all", "All"), filterValue: false },
    { key: user?.id || 0, value: user?.id || 0, text: `${user?.first_name} ${user?.last_name}`, filterValue: true }
  ];

  return { customerOkUserOptions };
};
